import { lazy } from "react";

const AdviceTeacher = lazy(() =>
    import("@views/AdviceTeacher/"),
);
const AdviceTeacherMain = lazy(() =>
    import("@views/AdviceTeacher/Groups")
);


const AdviceTeacherRoutes = [
    {
        path: "advice/teacher",
        element: <AdviceTeacherMain />,
    },
    {
        path: "advice/teacher/:group_id/",
        element: <AdviceTeacher />,
    },
];
export default AdviceTeacherRoutes;
